import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './DashboardLayout.css';

const DashboardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="9" rx="1"></rect>
    <rect x="14" y="3" width="7" height="5" rx="1"></rect>
    <rect x="14" y="12" width="7" height="9" rx="1"></rect>
    <rect x="3" y="16" width="7" height="5" rx="1"></rect>
  </svg>
);
const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);
const ProfileIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);
const LogoutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);
export default function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const nameParts = user ? [user.firstName, user.lastName].filter(Boolean).join(' ') : '';
  const displayName = nameParts.trim() || 'User';
  const avatarUrl = user?.profileImageUrl;

  const handleConfirmLogout = () => {
    setShowLogoutConfirm(false);
    logout();
    navigate('/');
  };

  return (
    <div className="dashboard-layout">
      <nav className="dashboard-mobile-nav-wrap" aria-label="Account pages">
        <div className="dashboard-mobile-nav-strip">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `dashboard-mobile-nav-pill${isActive ? ' dashboard-mobile-nav-pill--active' : ''}`
            }
          >
            <DashboardIcon />
            <span>Dashboard</span>
          </NavLink>
          <NavLink
            to="/bookings"
            className={({ isActive }) =>
              `dashboard-mobile-nav-pill${isActive ? ' dashboard-mobile-nav-pill--active' : ''}`
            }
          >
            <CalendarIcon />
            <span>Bookings</span>
          </NavLink>
          <NavLink
            to="/profile"
            className={({ isActive }) =>
              `dashboard-mobile-nav-pill${isActive ? ' dashboard-mobile-nav-pill--active' : ''}`
            }
          >
            <ProfileIcon />
            <span>Profile</span>
          </NavLink>
          <button
            type="button"
            className="dashboard-mobile-nav-pill dashboard-mobile-nav-pill--logout"
            onClick={() => setShowLogoutConfirm(true)}
          >
            <LogoutIcon />
            <span>Logout</span>
          </button>
        </div>
      </nav>

      <aside id="dashboard-sidebar" className="dashboard-sidebar">
        <div className="dashboard-user-card">
          <div className="dashboard-avatar">
            {avatarUrl ? (
              <img src={avatarUrl} alt="" />
            ) : (
              <span>{displayName.charAt(0).toUpperCase()}</span>
            )}
          </div>
          <h3 className="dashboard-user-name">{displayName}</h3>
          <p className="dashboard-user-tag">Nature Enthusiast</p>
          <span className="dashboard-verified-badge">Verified Member</span>
        </div>
        <nav className="dashboard-nav">
          <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'dashboard-nav-link active' : 'dashboard-nav-link'}>
            <DashboardIcon /> Dashboard
          </NavLink>
          <NavLink to="/bookings" className={({ isActive }) => isActive ? 'dashboard-nav-link active' : 'dashboard-nav-link'}>
            <CalendarIcon /> My Bookings
          </NavLink>
          <NavLink to="/profile" className={({ isActive }) => isActive ? 'dashboard-nav-link active' : 'dashboard-nav-link'}>
            <ProfileIcon /> Profile Settings
          </NavLink>
          <button type="button" className="dashboard-nav-link logout-btn" onClick={() => setShowLogoutConfirm(true)}>
            <LogoutIcon /> Logout
          </button>
        </nav>
      </aside>
      <div className="dashboard-main">
        {children}
      </div>
      {showLogoutConfirm && (
        <div className="logout-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="logout-modal-title">
          <div className="logout-modal">
            <h3 id="logout-modal-title">Are you sure you want to log out?</h3>
            <p>You will need to sign in again to access your dashboard and profile.</p>
            <div className="logout-modal-actions">
              <button type="button" className="logout-modal-btn cancel" onClick={() => setShowLogoutConfirm(false)}>
                Cancel
              </button>
              <button type="button" className="logout-modal-btn confirm" onClick={handleConfirmLogout}>
                Yes, Log out
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
